
<div>
  <p *ngIf="info.isPage" class="text-alert">
    <b>{{'PageInfoText' | translate}}</b>
    <span class="config-links">
      <a href="#" (click)="showPageComponentInfo($event)">{{'ClickHere' | translate}}</a>
    </span>
    <br/><br/>
  </p>

  <p *ngIf="info.busClassName"><span class="attribute-title label-colon">{{'BusinessClass' | translate}}</span><span class="attribute-answer"> {{info.busClassName}}</span></p>
  <p *ngIf="info.module"><span class="attribute-title label-colon">{{'Module' | translate}}</span> <span class="attribute-answer">{{info.module}}</span></p>

  <div *ngIf="info.cardviewSpec" class="titles">
    <b class="menu-title menu-layer">{{'CardViewInfo' | translate}}</b>
    <p *ngIf="info.cardviewSpec.id">
      <span class="attribute-title label-colon">{{'CardViewName' | translate}}</span> <span class="attribute-answer"> {{info.cardviewSpec.id}}</span>
    </p>
    <ng-container *ngTemplateOutlet="configInfoMarkup; context:{compInfo: info.cardviewSpec, busName:info.busClassName ,name:info.cardviewSpec.id}"></ng-container>
  </div>

  <div *ngIf="info.panelSpec" class="titles">
    <b class="menu-title menu-layer">{{'FormPanelInfo' | translate}}</b>
    <p *ngIf="info.panelSpec.formName">
      <span class="attribute-title label-colon">{{'PanelFormName' |translate}}</span> <span class="attribute-answer">{{info.panelSpec.formName}}</span>
    </p>
    <ng-container *ngTemplateOutlet="configInfoMarkup; context:{compInfo: info.panelSpec, busName:info.busClassName ,name:info.panelSpec.formName}"></ng-container>
  </div>

  <div *ngIf="info.contextFormSpec" class="titles">
    <b class="menu-title menu-layer">{{'ContextFormInfo' | translate }}</b>
    <p *ngIf="info.contextFormSpec.name">
      <span class="attribute-title label-colon">{{'ContextFormName' | translate}}</span><span class="attribute-answer"> {{info.contextFormSpec.name}}</span>
    </p>
    <p *ngIf="info.contextFormSpec.configuration">
      <span class="attribute-title">{{'IsConfigured' | translate}}</span>
    </p>
    <ng-container *ngTemplateOutlet="resourceInfoMarkup; context:{resourceInfo: info.contextFormSpec.resourceInfo}"></ng-container>
    <ng-container *ngTemplateOutlet="lplInfoMarkup; context:{lpl: info.contextFormSpec.lpl}"></ng-container>
    <ng-container *ngTemplateOutlet="configInfoMarkup; context:{compInfo: info.contextFormSpec, busName:info.busClassName ,name:info.contextFormSpec.name}"></ng-container>
  </div>

  <div *ngIf="info.panelSpec || info.contextFormSpec || info.cardviewSpec" class="titles">
    <b class="menu-title menu-layer">{{'ParentCompInformation' | translate: upperCase(info.componentType)}}</b>
  </div>

  <div *ngIf="info.panelSpec === undefined && !info.contextFormSpec && !info.cardviewSpec" class="titles">
    <b class="menu-title menu-layer">{{'CompInformation'| translate: upperCase(info.componentType)}}</b>
  </div>
  <!-- <p><b>{{'LPLViewName' | translate}}</b> {{info.name}}</p> -->


  <p><span class="attribute-title label-colon">{{'CompName' | translate: upperCase(info.componentType)}}</span> <span class="attribute-answer">{{info.name}}</span>
    <span class="config-links">
      <a *ngIf="info.listUrl" href="{{info.listUrl}}" target="_blank" class="open-links inline-open"><span class="attribute-answer">{{'Open' | translate}}</span></a>
      <a *ngIf="info.formRequestUrl" href="{{info.formRequestUrl}}" target="_blank" class="open-links inline-open"><span class="attribute-answer">{{'Open' | translate}}</span></a>
    </span>
  </p>
  <p *ngIf="info.formName" ><span class="attribute-title label-colon">{{'FormName' | translate}}</span> <span class="attribute-answer">{{info.formName}}</span></p>
  <p *ngIf="info.userWebRequestId"><span class="attribute-title label-colon">{{'UICompId' | translate}}</span> <span class="attribute-answer">{{info.userWebRequestId}}</span></p>

  <p *ngIf="info.pageTitle"><span class="attribute-title label-colon">{{'PageTitle' | translate}}</span> <span class="attribute-answer">{{info.pageTitle}}</span></p>
  <p *ngIf="info.fieldSize"><span class="attribute-title label-colon">{{'FieldSize' | translate}}</span> <span class="attribute-answer">{{info.fieldSize}}</span></p>
  <p *ngIf="info.fieldSize && info.type"><span class="attribute-title label-colon">{{'FieldType' | translate}}</span> <span class="attribute-answer">{{info.type}}</span></p>
  <p *ngIf="info.parentLink && (info.parentLink !== info.name)"><span class="attribute-title label-colon">{{'ParentLink' | translate}}</span> <span class="attribute-answer">{{info.parentLink}}</span></p>
  <div *ngIf="info.stateValues" style="display: flex">
    <p><span class="attribute-title label-colon">{{'StateValues' | translate}}</span></p>
    <section class="scrollable-flex-header expandable-area custom-inline-expand" [class.is-expanded]="false" style="flex-grow: 1;">
      <div class="expandable-pane">
        <pre> {{info.stateValues}} </pre>
      </div>
    </section>
  </div>

  <p *ngIf="info.chartName"><span class="attribute-title label-colon">{{'ChartName' | translate}}</span> <span class="attribute-answer">{{info.chartName}}</span></p>
  <!-- <p *ngIf="info.resourceId"><span class="attribute-title label-colon">{{'ResourceId' | translate}}</span> <span class="attribute-answer">{{info.resourceId}}</span></p>  -->
  <p *ngIf="info.resourceType"><span class="attribute-title label-colon">{{'ResourceType' | translate}}</span> <span class="attribute-answer">{{info.resourceType}}</span></p>

  <!-- <div *ngIf="info.listUrl" class="titles">
      <b>{{'ListUrl' | translate}}</b>
      <a href="{{info.listUrl}}" target="_blank">{{'Open' | translate}}</a>
      <a href="#" (click)="showHideListUrl(); ">{{'ShowHideUrl' | translate}}</a>
      <div class="url-content" *ngIf="showListUrl">{{info.listUrl}}</div>
  </div> -->

  <ng-container *ngTemplateOutlet="resourceInfoMarkup; context:{resourceInfo: info.resourceInfo}"></ng-container>

  <div *ngIf="info.link" class="titles">
    <b class="menu-title label-colon">{{'Menu' | translate}}</b>
    <p *ngIf="info.id"><span class="attribute-title label-colon">{{'IdLabel' | translate}}</span> <span class="attribute-answer">{{info.id}}</span></p>
    <p *ngIf="info.label"><span class="attribute-title label-colon">{{'MenuLabel' | translate}}</span> <span class="attribute-answer">{{info.label}}</span></p>
    <p *ngIf="info.link"><span class="attribute-title label-colon">{{'MenuLink' | translate}}</span> <span class="attribute-answer">{{info.link}}</span></p>
    <p *ngIf="info.menuIndex"><span class="attribute-title label-colon">{{'MenuIndex' | translate}}</span> <span class="attribute-answer">{{info.menuIndex}}</span></p>
    <p *ngIf="info.parent"><span class="attribute-title label-colon">{{'Parent' | translate}}</span> <span class="attribute-answer">{{info.parent}}</span></p>
    <p *ngIf="info.parentLabel"><span class="attribute-title label-colon">{{'ParentLabel' | translate}}</span><span class="attribute-answer"> {{info.parentLabel}}</span></p>
    <p *ngIf="info.target"><span class="attribute-title label-colon">{{'MenuTarget' | translate}}</span><span class="attribute-answer"> {{info.target}}</span></p>
  </div>
  <ng-container *ngTemplateOutlet="configInfoMarkup; context:{compInfo: info, busName:info.busClassName ,name:info.name}"></ng-container>

  <div *ngIf="info.developer">
        <button class="collapse-button" type="button"  (click)="toggleDeveloper()">
          <span><b  class="collapse-titles label-colon">{{'DeveloperInformation' | translate}}</b></span>
          <svg *ngIf="!showDeveloper" class="icon icon-closed icon-pos" focusable="false" aria-hidden="true" role="presentation">
            <use href="#icon-caret-down"></use>
          </svg>
          <svg *ngIf="showDeveloper" class="icon icon-opened icon-pos" focusable="false" aria-hidden="true" role="presentation">
            <use href="#icon-caret-up"></use>
          </svg>
        </button>
        <div>
          <div [@detailExpand]="showDeveloper ? 'expanded' : 'collapsed'" class="animate-developer" >
            <div class="content icon-pos">
              <ng-container *ngTemplateOutlet="developerInfoMarkup; context:{compInfo: info}"></ng-container>
            </div>
          </div>
        </div>
  </div>

  <div>
    <button class="collapse-button" type="button"  (click)="toggleDebugger()">
      <div>
        <span><b class="collapse-titles">{{'DebugTool' | translate}}</b></span>
        <svg *ngIf="!showDebug" class="icon icon-closed icon-pos" focusable="false" aria-hidden="true" role="presentation">
          <use href="#icon-caret-down"></use>
        </svg>
        <svg *ngIf="showDebug" class="icon icon-opened icon-pos" focusable="false" aria-hidden="true" role="presentation">
          <use href="#icon-caret-up"></use>
        </svg>
      </div>
    </button>

    <div>
      <div [@detailExpand]="showDebug ? 'expanded' : 'collapsed'" class="animate-developer" >
        <div class="content icon-pos debug-container">
          <ng-container *ngTemplateOutlet="showDebugMarkup; context:{compInfo: info}"></ng-container>
        </div>
      </div>
    </div>
  </div>

  <!--  REUSE TEMPLATES BELOW  -->

  <ng-template let-developernfo="developerInfo" let-compInfo="compInfo" #showDebugMarkup>
    <div class="field debug-input-field">
      <a id="primary-aslink" class="btn-primary debug-button debug-title" href="#" (click)="openDebugger();">
       <span>{{'OpenDebugger' | translate}}</span>
      </a>
      <input type="checkbox" class="checkbox" name="checkbox1"  id="debugtrace" #debugTrace  (click)="toggleTrace(debugTrace.checked);"/>
      <label for="debugtrace" class="checkbox-label debug-title debug-checkbox-label">{{'OpenTrace' | translate}}</label>
    </div>
    <div class="field debug-input-field">
      <p class="debug-paragraph">
        <span class="attribute-title label-colon">{{'DBSessionName' | translate}}</span> <span class="attribute-answer">
            <input type="text" id="dbSessionId" class="debug-title debug-name" name="dbSessionId" #debugSessionId  (change)="changeDebugID(debugSessionId.value);" value="{{debugName}}"/>
        </span>
      </p>
    </div>
    <div class="field debug-input-field">
      <p class="debug-paragraph">
        <span class="attribute-title label-colon">{{'DBDebugLevel' | translate}}</span> <span class="attribute-answer">
          <select id="debugLevelId" name="debugLevelId" class="dropdown debug-level-element" #debugLevel (change)="setDebugLevel(debugLevel.value);">
            <option value="minimal">Minimal</option>
            <option value="basic">Basic</option>
            <option value="standard" selected >Standard</option>
            <option value="verbose">Verbose </option>
          </select>
        </span>
      </p>
    </div>
    <hr class="debug-split" /><br/><br/>
    <div class="field">
      <a id="primary-aslink" class="btn-primary debug-button debug-title" href="#" (click)="openSecurityDebugger();">
        <span>{{'OpenSecDebugger' | translate}}</span>
      </a>
    </div>
  </ng-template>

  <ng-template let-developerInfo="developerInfo" let-compInfo="compInfo" #developerInfoMarkup>
    <p><span class="attribute-title label-colon">{{'ComponentType' | translate}}</span> <span class="attribute-answer">{{info.componentType | capitalize}}</span></p>
    <p *ngIf="info.fieldSize === undefined"><span class="attribute-title label-colon">{{'ViewType' | translate}}</span> <span class="attribute-answer">{{info.type}}</span></p>
    <p *ngIf="info.panelSpec && info.panelSpec.panelId"><span class="attribute-title label-colon">{{'PanelId' | translate}}</span> <span class="attribute-answer">{{info.panelSpec.panelId}}</span></p>
    <p *ngIf="info.displayType"><span class="attribute-title label-colon">{{'DisplayType' | translate}}</span> <span class="attribute-answer">{{info.displayType}}</span></p>
    <p *ngIf="info.fromListResourceId"><span class="attribute-title label-colon">{{'FromListResourceId' | translate}}</span> <span class="attribute-answer">{{info.fromListResourceId}}</span></p>
    <p *ngIf="info.status">{{info.componentType | capitalize}} <span class="attribute-title label-colon">{{'Status' | translate}}</span> <span class="attribute-answer">{{info.status}}</span></p>
    <p *ngIf="info.developer && compInfo.configInfo && compInfo.configInfo.configStamp && compInfo.configInfo.configStamp > 0"><span class="attribute-title label-colon">{{'ConfigStamp' | translate}}</span> {{compInfo.configInfo.configStamp}}</p>
    <p *ngIf="info.developer && compInfo.configInfo && compInfo.configInfo.classConfigStamp && compInfo.configInfo.classConfigStamp > 0"><span class="attribute-title label-colon">{{'ClassConfigStamp' | translate}}</span> {{compInfo.configInfo.classConfigStamp}}</p>
    <p *ngIf="info.panelNavigation"><span class="attribute-title label-colon">{{'PanelNavigation' | translate}}</span> <span class="attribute-answer">{{info.panelNavigation}}</span></p>
    <p *ngIf="info.isWizard"><span class="attribute-title label-colon">{{'IsWizard' | translate}}</span> {{info.isWizard}}</p>
    <div *ngIf="info.specField" style="display: flex">
      <p><span class="attribute-title label-colon">{{'SpecField' | translate}}</span></p>
      <section class="scrollable-flex-header expandable-area custom-inline-expand" [class.is-expanded]="false" style="flex-grow: 1;">
        <div class="expandable-pane">
          <pre> {{info.specField}} </pre>
        </div>
      </section>
    </div>
    <div *ngIf="info.fieldLayout" style="display: flex">
      <p><span class="attribute-title label-colon">{{'Layout' | translate}}</span></p>
      <section class="scrollable-flex-header expandable-area custom-inline-expand" [class.is-expanded]="false" style="flex-grow: 1;">
        <div class="expandable-pane">
          <pre> {{info.fieldLayout}} </pre>
        </div>
      </section>
    </div>
    <div *ngIf="info.formRequestUrl" class="titles link-group-xpand">
      <span class="attribute-title label-colon">{{'FormUrl' | translate}}</span>
      <span  class="config-links">
        <a href="{{info.formRequestUrl}}" target="_blank" class="page-open-links"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
        <a href="#" (click)="showHideFormRequestUrl(); "><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      </span>

      <div class="url-content" *ngIf="showFormRequestUrl">{{info.formRequestUrl}}</div>
    </div>
    <div *ngIf="info.firstPageUrl" class="titles config-links link-group-xpand">
      <span class="attribute-title">{{'FirstPage' | translate}}</span>
      <a href="{{info.firstPageUrl}}" target="_blank" class="page-open-links"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="#" (click)="showHideFirstPageUrl();"><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      <div class="url-content" *ngIf="showFirstPageUrl">{{info.firstPageUrl}}</div>
    </div>
    <div *ngIf="info.nextPageUrl" class="titles config-links link-group-xpand">
      <span class="attribute-title">{{'NextPage' | translate}}</span>
      <a href="{{info.nextPageUrl}}" target="_blank" class="page-open-links"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="#" (click)="showHideNextPageUrl();"><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      <div class="url-content" *ngIf="showNextPageUrl">{{info.nextPageUrl}}</div>
    </div>
    <div *ngIf="info.previousPageUrl" class="titles config-links link-group-xpand">
      <span class="attribute-title">{{'PreviousPage' | translate}}</span>
      <a href="{{info.previousPageUrl}}" target="_blank" class="page-open-links"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="#" (click)="showHidePreviousPageUrl(); "><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      <div class="url-content" *ngIf="showPreviousPageUrl">{{info.previousPageUrl}}</div>
    </div>
    <div *ngIf="info.lastPageUrl" class="titles config-links link-group-xpand">
      <span class="attribute-title">{{'LastPage' | translate}}</span>
      <a href="{{info.lastPageUrl}}" target="_blank" class="page-open-links"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="#" (click)="showHideLastPageUrl();"><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      <div class="url-content" *ngIf="showLastPageUrl">{{info.lastPageUrl}}</div>
    </div>
    <div *ngIf="info.reloadPageUrl" class="titles config-links link-group-xpand">
      <span class="attribute-title">{{'ReloadPage' | translate}}</span>
        <a href="{{info.reloadPageUrl}}" target="_blank" class="page-open-links"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
        <a href="#" (click)="showHideReloadPageUrl();"><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
        <div class="url-content" *ngIf="showReloadPageUrl">{{info.reloadPageUrl}}</div>
    </div>

    <div *ngIf="info.nextRecordUrl" class="titles config-links link-group-xpand">
      <span class="attribute-title">{{'NextRecord' | translate}}</span>
      <a href="{{info.nextRecordUrl}}" target="_blank" class="page-open-links"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="#" (click)="showHideNextRecordUrl();"><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      <div class="url-content" *ngIf="showNextRecordUrl">{{info.nextRecordUrl}}</div>
    </div>
    <div *ngIf="info.previousRecordUrl" class="titles config-links link-group-xpand">
      <span class="attribute-title">{{'PreviousRecord' | translate}}</span>
      <a href="{{info.previousRecordUrl}}" target="_blank" class="page-open-links"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="#" (click)="showHidePreviousRecordUrl();"><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      <div class="url-content" *ngIf="showPreviousRecordUrl">{{info.previousRecordUrl}}</div>
    </div>
    <div *ngIf="info.reloadRecordUrl" class="titles config-links link-group-xpand">
      <span class="attribute-title">{{'ReloadRecord' | translate}}</span>
      <a href="{{info.reloadRecordUrl}}" target="_blank" class="page-open-links"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="#" (click)="showHideReloadRecordUrl();"><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      <div class="url-content" *ngIf="showReloadRecordUrl">{{info.reloadRecordUrl}}</div>
    </div>
    <ng-container *ngTemplateOutlet="lplInfoMarkup; context:{lpl: info.lpl}"></ng-container>
    <div *ngIf="info.loadedUrl" class="titles">
      <span class="attribute-title label-colon">{{'UrlLoadedToIframe' | translate}}</span>
      <a href="{{info.loadedUrl}}" target="_blank" class="page-open-links"><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="#" (click)="showHideLoadedUrl(); "><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      <div class="url-content" *ngIf="showLoadedUrl">{{info.loadedUrl}}</div>
    </div>
    <div *ngIf="info.inputUrl" class="titles">
      <span class="attribute-title label-colon">{{'UrlPassedToComponent' | translate}}</span>
      <a href="{{info.inputUrl}}" target="_blank" class="pageOpenpage-open-linksLinks"attribut><span class="attribute-answer">{{'Open' | translate}}</span></a><span class="pipe-spacing">|</span>
      <a href="#" (click)="showHideInputUrl(); "><span class="attribute-answer">{{'ShowHideUrl' | translate}}</span></a>
      <div class="url-content" *ngIf="showInputUrl">{{info.inputUrl}}</div>
    </div>
    <div *ngIf="info.pageSpec" style="display: flex">
      <p><span class="attribute-title label-colon">{{'PageSpec' | translate}}</span></p>
      <section class="scrollable-flex-header expandable-area custom-inline-expand" [class.is-expanded]="false" style="flex-grow: 1;">
        <div class="expandable-pane">
          <pre> {{info.pageSpec}} </pre>
        </div>
      </section>
    </div>
    <p *ngIf="info.hasPanels"><span class="attribute-title label-colon">{{'HasPanels' | translate}}</span> <span class="attribute-answer">{{info.hasPanels}}</span></p>
    <div *ngIf="info.lmTabsOptions" style="display: flex">
      <p><span class="attribute-title label-colon">{{'TabOptions' | translate}}</span></p>
      <section class="scrollable-flex-header expandable-area custom-inline-expand" [class.is-expanded]="false" style="flex-grow: 1;">
        <div class="expandable-pane">
          <pre> {{info.lmTabsOptions}} </pre>
        </div>
      </section>
    </div>
    <p *ngIf="info.overrideListTitle"><span class="attribute-title label-colon">{{'OverrideListTitle' | translate}}</span> <span class="attribute-answer">{{info.overrideListTitle}}</span></p>
    <p *ngIf="info.hideTitleBar"><span class="attribute-title label-colon">{{'HideTitleBar' | translate}}</span>  <span class="attribute-answer">{{info.hideTitleBar}}</span> </p>
    <p *ngIf="info.toolbarButtons"><span class="attribute-title label-colon">{{'ToolbarButtons' | translate}}</span>  <span class="attribute-answer">{{info.toolbarButtons}}</span> </p>
    <p *ngIf="info.bottomSpacing"><span class="attribute-title label-colon">{{'BottomSpacing' | translate}}</span>  <span class="attribute-answer">{{info.bottomSpacing}}</span> </p>
    <p *ngIf="info.adjustFrameToWindow || info.adjustFrameToWindow === false"><span class="attribute-title label-colon">{{'AdjustFrameToWindow' | translate}}</span>  <span class="attribute-answer">{{info.adjustFrameToWindow}}</span> </p>
    <p *ngIf="info.isDashboardPanel || info.isDashboardPanel === false"><span class="attribute-title label-colon">{{'IsDashboardPanel' | translate}}</span>  <span class="attribute-answer">{{info.isDashboardPanel}}</span> </p>
    <p *ngIf="info.fieldManualRep || info.fieldManualRep === false"><span class="attribute-title label-colon">{{'fieldManualRep' | translate}}</span>  <span class="attribute-answer">{{info.fieldManualRep}}</span> </p>
    <p *ngIf="info.uniqueId"><span class="attribute-title label-colon">{{'UniqueId' | translate}}</span>  <span class="attribute-answer">{{info.uniqueId}}</span> </p>
    <p *ngIf="info.showLoading || info.showLoading === false"><span class="attribute-title label-colon">{{'ShowLoading' | translate}}</span>  <span class="attribute-answer">{{info.showLoading}}</span> </p>
    <p *ngIf="info.manualRepFields"><span class="attribute-title label-colon">{{'ManualRepFields' | translate}}</span>  <span class="attribute-answer">{{info.manualRepFields}}</span> </p>
    <p *ngIf="info.isHtmlFragment"><span class="attribute-title label-colon">{{'HtmlFragment' | translate}}</span>  <span class="attribute-answer">{{info.isHtmlFragment}}</span> </p>
   <!-- <p *ngIf="info.developer"><span class="attribute-title label-colon">{{'Developer' | translate}}</span>  <span class="attribute-answer">{{info.developer}}</span> </p> -->

</ng-template>

<ng-template let-resourceInfo="resourceInfo" #resourceInfoMarkup>
  <p *ngIf="resourceInfo && resourceInfo.resourceObject"><span class="attribute-title label-colon">{{'ResourceObject' | translate}}</span> <span class="attribute-answer">{{resourceInfo.resourceObject}}</span></p>
  <p *ngIf="resourceInfo && resourceInfo.resourceKey"><span class="attribute-title label-colon">{{'ResourceKey' | translate}}</span> <span class="attribute-answer">{{resourceInfo.resourceKey}}</span></p>
  <p *ngIf="resourceInfo && resourceInfo.resourceValue"><span class="attribute-title label-colon">{{'ResourceValue' | translate}}</span><span class="attribute-answer">{{resourceInfo.resourceValue}}</span></p>
</ng-template>

<ng-template let-lpl="lpl" #lplInfoMarkup>
  <div *ngIf="lpl" style="display: flex">
    <p><span class="attribute-title label-colon">LPL</span></p>
    <section class="scrollable-flex-header expandable-area custom-inline-expand" [class.is-expanded]="false" style="flex-grow: 1;">
    <div class="expandable-pane">
      <pre> {{lpl}} </pre>
    </div>
    </section>
  </div>
</ng-template>

<ng-template let-compInfo="compInfo" let-busName="busName" let-name="name" #configInfoMarkup>
  <div *ngIf="compInfo.configInfo" class="titles">
    <p *ngIf="compInfo.configInfo.personalization" class="config-tag-line">
      <span class="attribute-title"><span class="config-tag">{{'IsPersonalized' | translate}}</span></span>
    </p>
    <p *ngIf="!compInfo.configInfo.personalization && compInfo.configInfo.configuration" class="config-tag-line">

      <span class="attribute-title"><span class="config-tag">{{'IsConfigured' | translate}}</span></span>
      <span *ngIf="compInfo.configInfo.configuration && info.hasConfigAccess">
        <a href="#" class="config-links" (click)="viewConfiguration(compInfo, busName, name)" class="create-config"><span class="attribute-answer">{{'ViewConfiguration' | translate}}</span></a>
      </span>
    </p>

    <p *ngIf="!compInfo.configInfo.personalization && !compInfo.configInfo.configuration && !compInfo.configInfo.configureUrl && !compInfo.configInfo.configureUrl
                    && !compInfo.configInfo.personalizeTabs && !compInfo.configInfo.userlist && !compInfo.configInfo.folder && !compInfo.configInfo.configStamp" class="config-tag-line">

      <span *ngIf="info.hasConfigAccess" class="attribute-title"><span class="delivered-tag">{{'NoConfigurationInfo' | translate}}</span></span>
      <span *ngIf="!info.hasConfigAccess" class="attribute-title" style="width: 100%;"><span class="delivered-tag">{{'NoConfigurationInfo' | translate}}</span></span>
      <span *ngIf="info.hasConfigAccess  && !compInfo.configInfo.configuration" class="config-links" >
        <a href="#" (click)="createConfiguration(compInfo, busName, name);" class="create-config"><span class="attribute-answer">{{'CreateConfiguration' | translate}}</span></a>
      </span>
    </p>

     <p *ngIf="info.hasConfigAccess"  class="config-tag-line">
      <span class="attribute-title label-colon">{{'ViewDelivered' | translate}}</span>
      <span class="delivered-config">
        <a href="#" (click)="runViewBaseLpl(compInfo, busName, name);"><span class="attribute-answer">{{'UI' | translate}}</span></a>
        <ng-container *ngIf="busName">
          <span class="pipe-spacing">|</span>
          <a href="#" (click)="runViewBusinessLogic(compInfo, busName, name);"><span class="attribute-answer">{{'BusinessClass' | translate}}</span></a>
        </ng-container>
      </span>
    </p>

    <p *ngIf="compInfo.configInfo.personalizeTabs"><span class="attribute-title label-colon">{{'PersonalizeTabs' | translate}}</span> {{compInfo.configInfo.personalizeTabs}}</p>
    <p *ngIf="compInfo.configInfo.folder"><span class="attribute-title label-colon">{{'Folder' | translate}}</span> {{compInfo.configInfo.folder}}</p>
    <p *ngIf="compInfo.configInfo.userlist"><span class="attribute-title label-colon">{{'UserList' | translate}</span> {{compInfo.configInfo.userlist}}</p>

  </div>
</ng-template>